import { z } from "zod"
import { DurationSchema, TimelineSchema } from "./timing"

export const MusicAudioSettingsSchema = z.object({
  volume: z.number().min(0).max(100).default(50),
  fadeInMs: z.number().min(0).max(5000).default(500),
  fadeOutMs: z.number().min(0).max(5000).default(500),
  loop: z.boolean().default(false),
  duckUnderSpeech: z.boolean().default(true),
  duckLevel: z.number().min(0).max(100).default(50),
})

export const MusicMediaInfoSchema = z.object({
  mediaType: z.literal("audio").default("audio"),
  originUrl: z.string(),
  previewUrl: z.string(),
  duration: z.number(),
  title: z.string().nullable().default(null),
  artist: z.string().nullable().default(null),
  sourceId: z.string().nullable().default(null),
  waveformData: z.array(z.number()).nullable().default(null),
  genre: z.string().nullable().default(null),
  coverImage: z.string().nullable().default(null),
})

export const MusicContentSchema = z.object({
  id: z.string(),
  musicType: z.enum(["Stock", "Uploaded"]).default("Stock"),
  mediaInfo: MusicMediaInfoSchema,
  audioSettings: MusicAudioSettingsSchema.default({}),
})

export const MusicSegmentSchema = z.object({
  id: z.string(),
  contentType: z.literal("Music"),
  duration: DurationSchema,
  timeline: TimelineSchema,
  trimStartMs: z.number().optional().describe("Where this piece starts in its media (ms); set when a segment is split"),
  content: MusicContentSchema,
})

export type MusicAudioSettings = z.infer<typeof MusicAudioSettingsSchema>
export type MusicMediaInfo = z.infer<typeof MusicMediaInfoSchema>
export type MusicContent = z.infer<typeof MusicContentSchema>
export type MusicSegment = z.infer<typeof MusicSegmentSchema>
